let contactPeople = [
  { 
    name: "Madalina Codrescu", 
    function: "Coordonator" , 
    img: "https://i.imgur.com/sdlqiru.jpg",
    email: "madalina.codrescu@eestec.ro",
    phone: '0787820809'
  },
  { 
    name: "Iulia Iamandei", 
    function: "Presedinte" , 
    img: "https://i.imgur.com/2IdbuMP.jpg",
    email: "iulia.iamandei@eestec.ro",
    phone: '0729740116'

  }

]

export default contactPeople;